import "bootstrap/js/dist/collapse";